import { render, staticRenderFns } from "./ReportSales.vue?vue&type=template&id=6b19c396&"
import script from "./ReportSales.vue?vue&type=script&lang=js&"
export * from "./ReportSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports